const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/qr91qd1dl84w-UZ/image;s=644x461",
        title: "Тоза конли корабайир бия",
        price: "2 000 у.е.",
        location: "Зангиата"
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/0g2pghiozss32-UZ/image;s=644x461",
        title: "Продаются Шотландские котята",
        price: "100 у.е.",
        location: "Самарканд",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/5kpp4u4h0gki-UZ/image;s=644x461",
        title: "Бройлер циплята по оптовым ценам ЖУЖА ROSS-308",
        price: "6 000 сум",
        location: "Самарканд",
    },
]

export default data;